import { useFormContext } from './form';
import NumberField from '../../Base/NumberField';
import React from 'react';

export function FormField({
    name,
    ...rest
}) {
    const form = useFormContext();
    const conf = form.config[name] || {};
    const value = form.values[name];
    const error = form.errors[name];

    return (
        <Field
            name={name}
            value={value}
            onChange={form.onChange}
            type={conf.type}
            label={conf.label}
            required={conf.required}
            error={error}
            disabled={conf.disabled && conf.disabled(form)}
            {...rest}
        />
    );
}

export function Field({
    value, label, error, ...rest
}) {
    return (
        <NumberField
            value={value === null || value === undefined ? '' : value}
            floatingLabelText={label}
            fullWidth
            floatingLabelStyle={error ? { color: '#f44336' } : {}}
            className={error && 'hasValidationError'}
            errorText={error}
            {...rest}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormField.jsx